import _ from "lodash";
import React from "react";
import { colors } from "Constants";
import classNames from "classnames";
import { getStyleStrippedText } from "./htmlSanitize";

const styles = {
  archivedText: {
    color: colors.textDisabled,
    marginLeft: "4px",
    display: "inline",
  },
};

const getUpdatedArchivedFilters = (filters = {}, { entityType, entityId }) => {
  return {
    ...filters,
    archivalState: "ACTIVE",
    includeArchived: entityId ? { entityType, entityId } : undefined,
  };
};

const hasArchivedStudentsInList = data => {
  const totalEntities = _.size(
    _.filter(
      data,
      item =>
        _.get(item, "student.isArchived") || _.get(item, "node.isArchived")
    )
  );
  return totalEntities > 0;
};

const getLabelWithArchivedText = ({
  label,
  isArchived,
  t,
  customLabelTextClass,
  customArchivedContainerClass,
  shouldDangerouslyInjectLabel = false,
}) => {
  const labelClass = classNames({
    ["inline"]: true,
    [customLabelTextClass]: customLabelTextClass,
  });
  const containerClass = classNames({
    ["block"]: true,
    [customArchivedContainerClass]: customArchivedContainerClass,
  });
  return (
    <div className={containerClass}>
      {shouldDangerouslyInjectLabel ? (
        <div
          className={labelClass}
          dangerouslySetInnerHTML={{
            __html: getStyleStrippedText({
              text: label,
              type: "SANITIZE_DANGER_HTML_PARAGRAPH",
            }),
          }}
        />
      ) : (
        <div className={labelClass}>{label}</div>
      )}
      {isArchived ? (
        <div style={styles.archivedText}>{`(${t("common:archived")})`}</div>
      ) : null}
    </div>
  );
};

const getArchivedText = ({ name, isArchived, t }) => {
  if (t) return name + (isArchived ? ` (${t("common:archived")})` : ``);
  else return name + (isArchived ? ` (Archived)` : ``);
};

const getArchivedSortedSubjectList = ({ subjectList }) => {
  return _.orderBy(subjectList, ["isArchived"], ["asc"]);
};

const getArchivedSortedSubjectListMemoized = _.memoize(
  params => getArchivedSortedSubjectList(params),
  props => JSON.stringify(props)
);

export {
  getUpdatedArchivedFilters,
  hasArchivedStudentsInList,
  getLabelWithArchivedText,
  getArchivedText,
  getArchivedSortedSubjectListMemoized,
};
